export default __webpack_public_path__ + "static/media/Chalten20.20d7d40c.jpg";